import { gql } from "@apollo/client";

export const purchaseFragment = gql`
    fragment PurchaseFragment on Licence {
        id
        code
        activatedAt
        activeFrom
        activeTill
        package {
            id
            name
            description
            type
            validTimeInMonths
        }
        camera {
            id
            name
            country
            status
            hardwareInfo {
                imei
                sn
                msisdn
            }
            user {
                id
                firstname
                lastname
                email
            }
        }
    }
`;
